import React from 'react';
import { number, shape, string } from 'prop-types';
import { fromCents, numberWithCommas } from 'utils/helpers';
import QuestionText from '../reusable/QuestionText';
import RadioBoxesWithInput from '../reusable/RadioBoxesWithInput';
import { fieldNames, frequencies } from '../const';

const HousingExpensesQuestion = ({ declaredHousingCosts, selectedValue }) => {
  const { amount, frequency } = declaredHousingCosts;
  const shouldShowTextInput = selectedValue === 'OTHER';
  const housingExpensesOptions = [
    {
      title: 'followup.question.housingExpenses.yes',
      value: 'PERSONAL_SHARE',
    },
    {
      title: 'followup.question.housingExpenses.no',
      value: 'HALF_SHARED',
    },
    {
      title: 'followup.question.housingExpenses.other',
      value: 'OTHER',
    },
  ];

  return (
    <div className="followup__question-container">
      <QuestionText
        textId="followup.question.housingExpenses"
        values={{ amount: numberWithCommas(fromCents(amount)), frequency: frequencies[frequency] }}
      />

      <RadioBoxesWithInput
        fieldName={fieldNames.housingExpenses}
        options={housingExpensesOptions}
        shouldShowTextInput={shouldShowTextInput}
        textInputName={fieldNames.housingExpensesClarification}
        textInputTitleId="followup.question.housingExpenses.clarification"
      />
    </div>
  );
};

HousingExpensesQuestion.propTypes = {
  declaredHousingCosts: shape({
    amount: number,
    frequency: string,
  }),
  selectedValue: string,
};

export default HousingExpensesQuestion;
